import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { waLink, WHATSAPP_PRICING_URL } from './analytics';
import './App.css';
import './Pricing.css';

function Pricing() {
  const [activeTab, setActiveTab] = useState('umkm');
  const [expanded, setExpanded] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash === '#website-maintenance') {
      navigate('/website-maintenance', { replace: true });
    }
  }, [location.hash, navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab && ['umkm', 'startup', 'bisnis'].includes(tab)) {
      setActiveTab(tab);
    }
  }, [location.search]);

  const umkmPackages = [
    {
      name: 'Basic',
      price: '899.000',
      period: 'one-time',
      description: 'Solusi digital terjangkau untuk bisnis UMKM yang ingin go online',
      features: [
        'Website 3 halaman profesional',
        'Design responsif modern',
        '250MB disk space + unlimited bandwidth',
        'Free domain .my.id',
        'Shared hosting standard',
        'SSL certificate gratis'
      ],
      popular: false,
      color: '#f59e0b',
      icon: '🏪',
      guarantee: '30 hari garansi uang kembali'
    },
    {
      name: 'Standar',
      price: '1.299.000',
      originalPrice: '1.499.000',
      period: 'one-time',
      description: 'Solusi digital lengkap untuk UMKM yang ingin berkembang',
      features: [
        'Website 5 halaman profesional',
        'Design responsif modern',
        '500MB disk space + unlimited bandwidth',
        '1 email account profesional',
        'SEO dasar on-page',
        'Free domain .my.id',
        'Shared hosting premium',
        '1x revisi gratis per bulan',
        'SSL certificate gratis',
        'Dukungan teknis 1 bulan',
        '100% Garansi Kepuasan'
      ],
      popular: true,
      color: '#f59e0b',
      icon: '🏪',
      guarantee: '30 hari garansi uang kembali'
    },
    {
      name: 'Premium',
      price: '1.799.000',
      period: 'one-time',
      description: 'Solusi digital premium untuk UMKM yang ingin tampil profesional',
      features: [
        'Website 10 halaman premium',
        'Custom design dengan branding',
        '1GB disk space + unlimited bandwidth',
        '5 email accounts profesional',
        'SEO lanjutan on-page & off-page',
        'Free domain .com/.id/.co.id',
        'Business hosting premium',
        '3x revisi gratis per bulan',
        'Premium SSL certificate',
        'Dukungan teknis 3 bulan',
        '100% Garansi Kepuasan',
        '24/7 Support Priority'
      ],
      popular: false,
      color: '#f59e0b',
      icon: '🏪',
      guarantee: '60 hari garansi uang kembali'
    }
  ];

  const startupPackages = [
    {
      name: 'Basic',
      price: '1.499.000',
      period: 'one-time',
      description: 'Investasi cerdas untuk bisnis startup yang ingin tumbuh cepat',
      features: [
        'Website 5 halaman profesional',
        'Design responsif modern',
        '500MB disk space + unlimited bandwidth',
        'Free domain .my.id',
        'Shared hosting premium',
        'SSL certificate gratis',
        'Dukungan teknis 1 bulan'
      ],
      popular: false,
      color: '#10b981',
      icon: '🚀',
      guarantee: '30 hari garansi uang kembali'
    },
    {
      name: 'Standar',
      price: '2.499.000',
      period: 'one-time',
      description: 'Solusi lengkap untuk startup yang ingin scale up',
      features: [
        'Website 10 halaman premium',
        'Custom design dengan branding',
        '1GB disk space + unlimited bandwidth',
        '3 email accounts profesional',
        'SEO lanjutan on-page & off-page',
        'Free domain .com/.id/.co.id',
        'Business hosting premium',
        '2x revisi gratis per bulan',
        'Premium SSL certificate',
        'Dukungan teknis 3 bulan',
        '100% Garansi Kepuasan',
        '24/7 Support Priority'
      ],
      popular: true,
      color: '#10b981',
      icon: '🚀',
      guarantee: '60 hari garansi uang kembali'
    },
    {
      name: 'Premium',
      price: '3.999.000',
      period: 'one-time',
      description: 'Solusi premium untuk startup yang ingin go-to-market',
      features: [
        'Website unlimited halaman',
        'Custom design enterprise dengan branding',
        '2GB disk space + unlimited bandwidth',
        '5 email accounts profesional',
        'SEO enterprise lengkap dengan analytics',
        'Free domain semua ekstensi',
        'Business hosting dengan dedicated resources',
        'Unlimited revisi selama 6 bulan',
        'Premium SSL certificate + CDN',
        'Dukungan teknis 6 bulan',
        '100% Garansi Kepuasan',
        '24/7 Support Emergency',
        'Performance monitoring'
      ],
      popular: false,
      color: '#10b981',
      icon: '🚀',
      guarantee: '90 hari garansi uang kembali'
    }
  ];

  const bisnisPackages = [
    {
      name: 'Basic',
      price: '2.999.000',
      period: 'one-time',
      description: 'Solusi enterprise-grade untuk pertumbuhan bisnis maksimal',
      features: [
        'Website 10 halaman premium',
        'Custom design dengan branding',
        '1GB disk space + unlimited bandwidth',
        'Free domain .com/.id/.co.id',
        'Business hosting premium',
        'Premium SSL certificate',
        'Dukungan teknis 3 bulan',
        '5 email accounts profesional'
      ],
      popular: false,
      color: '#3b82f6',
      icon: '💼',
      guarantee: '60 hari garansi uang kembali'
    },
    {
      name: 'Standar',
      price: '4.999.000',
      period: 'one-time',
      description: 'Solusi komprehensif untuk bisnis yang ingin transformasi digital',
      features: [
        'Website unlimited halaman',
        'Custom design enterprise dengan branding',
        '3GB disk space + unlimited bandwidth',
        '10 email accounts profesional',
        'SEO enterprise lengkap dengan analytics',
        'Free domain semua ekstensi',
        'Business hosting dengan dedicated resources',
        'Unlimited revisi selama 1 tahun',
        'Premium SSL certificate + CDN',
        'Dukungan teknis 12 bulan',
        '100% Garansi Kepuasan',
        '24/7 Support Emergency',
        'Performance monitoring',
        'Monthly reporting'
      ],
      popular: true,
      color: '#3b82f6',
      icon: '💼',
      guarantee: '90 hari garansi uang kembali'
    },
    {
      name: 'Premium',
      price: '7.999.000',
      period: 'one-time',
      description: 'Solusi premium untuk bisnis enterprise dengan ROI tertinggi',
      features: [
        'Website unlimited halaman enterprise',
        'Custom design enterprise grade dengan branding',
        '5GB disk space + unlimited bandwidth',
        '20 email accounts profesional',
        'SEO enterprise lengkap dengan advanced analytics',
        'Free domain semua ekstensi + premium domains',
        'Enterprise hosting dengan dedicated resources',
        'Unlimited revisi selama 2 tahun',
        'Premium SSL certificate + CDN + security',
        'Dukungan teknis 24/7 priority',
        '100% Garansi Kepuasan',
        '24/7 Support Emergency',
        'Advanced performance monitoring',
        'Monthly detailed reporting',
        'On-site setup (Indonesia area)',
        'Data migration & backup',
        'Integration dengan existing systems'
      ],
      popular: false,
      color: '#3b82f6',
      icon: '💼',
      guarantee: '180 hari garansi uang kembali'
    }
  ];

  const currentPackages = activeTab === 'umkm' ? umkmPackages : 
                         activeTab === 'startup' ? startupPackages : 
                         bisnisPackages;

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>★</span>
    ));
  };

  return (
    <>
      <section className="pricing-hero">
        <div className="pricing-hero__inner">
          <div className="pricing-hero__content">
            <span className="pricing-hero__badge">💎 Investasi Cerdas untuk Pertumbuhan Bisnis</span>
            <h1 className="pricing-hero__title">
              Harga yang Transparan, 
              <span className="pricing-hero__title-accent">Hasil yang Maksimal</span>
            </h1>
            <p className="pricing-hero__subtitle">
              Solusi digital enterprise-grade dengan harga yang kompetitif. 
              Tidak ada biaya tersembunyi, hanya value yang melampaui ekspektasi.
            </p>
            <div className="pricing-hero__stats">
              <div className="pricing-hero__stat">
                <div className="pricing-hero__stat-number">3+</div>
                <div className="pricing-hero__stat-label">Klien Puas</div>
              </div>
              <div className="pricing-hero__stat">
                <div className="pricing-hero__stat-number">100%</div>
                <div className="pricing-hero__stat-label">Garansi Kepuasan</div>
              </div>
              <div className="pricing-hero__stat">
                <div className="pricing-hero__stat-number">24/7</div>
                <div className="pricing-hero__stat-label">Premium Support</div>
              </div>
            </div>
            <div className="pricing-hero__trust">
              <div className="trust-badges">
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Garansi Uang Kembali</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/>
                    <path d="M12 7v3m0 0v.01M12 21a9 9 0 110-18 0 9 9 0 010 18z"/>
                  </svg>
                  <span>Support 24/7</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Setup Cepat</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pricing-tabs">
        <div className="pricing-tabs__inner">
          <div className="pricing-tabs__nav">
            <button
              className={`pricing-tab ${activeTab === 'umkm' ? 'active' : ''}`}
              onClick={() => setActiveTab('umkm')}
            >
              <span className="pricing-tab__icon">🏪</span>
              <span className="pricing-tab__text">UMKM</span>
            </button>
            <button
              className={`pricing-tab ${activeTab === 'startup' ? 'active' : ''}`}
              onClick={() => setActiveTab('startup')}
            >
              <span className="pricing-tab__icon">🚀</span>
              <span className="pricing-tab__text">Startup</span>
            </button>
            <button
              className={`pricing-tab ${activeTab === 'bisnis' ? 'active' : ''}`}
              onClick={() => setActiveTab('bisnis')}
            >
              <span className="pricing-tab__icon">💼</span>
              <span className="pricing-tab__text">Bisnis</span>
            </button>
          </div>
        </div>
      </section>

      <section className="pricing-cards">
        <div className="pricing-cards__inner">
          <div className="pricing-grid">
            {currentPackages.map((pkg, index) => (
              <div key={pkg.name} className={`pricing-card ${pkg.popular ? 'popular' : ''}`} style={{ '--accent-color': pkg.color }}>
                {pkg.popular && (
                  <div className="pricing-card__badge">
                    <span className="pricing-card__badge-icon">{pkg.icon}</span>
                    <span className="pricing-card__badge-text">Most Popular</span>
                  </div>
                )}
                {pkg.originalPrice && (
                  <div className="pricing-card__discount-badge">
                    <span className="pricing-card__discount-text">DISKON</span>
                  </div>
                )}
                
                <div className="pricing-card__header">
                  <div className="pricing-card__icon-wrapper">
                    <div className="pricing-card__icon">{pkg.icon}</div>
                  </div>
                  <h3 className="pricing-card__name">{pkg.name}</h3>
                  <p className="pricing-card__description">{pkg.description}</p>
                  <div className="pricing-card__price">
                    {pkg.originalPrice && (
                      <div className="pricing-card__original-price">
                        <span className="pricing-card__currency">Rp</span>
                        <span className="pricing-card__original-amount">{pkg.originalPrice}</span>
                      </div>
                    )}
                    <div className="pricing-card__current-price">
                      <span className="pricing-card__currency">Rp</span>
                      <span className="pricing-card__amount">{pkg.price}</span>
                      <span className="pricing-card__period">/{pkg.period}</span>
                    </div>
                  </div>
                  <div className="pricing-card__value">
                    <span className="pricing-card__value-text">Best Value</span>
                    <div className="pricing-card__value-stars">
                      {renderStars(5)}
                    </div>
                  </div>
                </div>

                <div className="pricing-card__features">
                  <div className="pricing-card__features-header">
                    <span className="pricing-card__features-count">{pkg.features.length} Features</span>
                    <span className="pricing-card__features-included">All Included</span>
                  </div>
                  <ul className="pricing-card__features-list">
                    {(expanded[pkg.name] ? pkg.features : pkg.features.slice(0, 6)).map((feature, featureIndex) => (
                      <li key={featureIndex} className="pricing-card__feature">
                        <div className="pricing-card__check-wrapper">
                          <svg className="pricing-card__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 6L9 17l-5-5"/>
                          </svg>
                        </div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  {pkg.features.length > 6 && (
                    <button
                      className="pricing-card__toggle"
                      onClick={() => setExpanded(prev => ({ ...prev, [pkg.name]: !prev[pkg.name] }))}
                    >
                      {expanded[pkg.name] ? 'Show Less' : `Show ${pkg.features.length - 6} More`}
                    </button>
                  )}
                </div>

                <div className="pricing-card__action">
                  <a
                    href={waLink(`Halo, saya ingin memilih paket Website: ${pkg.name}. Mohon info lebih lanjut.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pricing-card__btn pricing-card__btn-primary"
                  >
                    <span className="pricing-card__btn-text">Pilih Paket</span>
                    <svg className="pricing-card__btn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                    </svg>
                  </a>
                  <div className="pricing-card__guarantee">
                    <div className="pricing-card__guarantee-icon">🛡️</div>
                    <div className="pricing-card__guarantee-text">
                      <div className="pricing-card__guarantee-title">{pkg.guarantee}</div>
                      <div className="pricing-card__guarantee-subtitle">100% Kepuasan</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </section>

      <section className="pricing-faq">
        <div className="pricing-faq__inner">
          <div className="pricing-faq__header">
            <h2 className="pricing-faq__title">Pertanyaan yang Sering Diajukan</h2>
            <p className="pricing-faq__subtitle">Jawaban untuk membantu Anda membuat keputusan yang tepat</p>
          </div>
          <div className="pricing-faq__grid">
            <div className="faq-item">
              <h3 className="faq-item__question">Apakah ada biaya maintenance bulanan?</h3>
              <p className="faq-item__answer">
                Biaya maintenance mulai dari Rp 200.000/bulan untuk website basic. 
                Termasuk hosting, domain, dan support teknis. Paket higher tier dapat diskon khusus.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="faq-item__question">Berapa lama proses pengerjaan?</h3>
              <p className="faq-item__answer">
                Website Basic: 3-5 hari kerja, Professional: 5-10 hari, Enterprise: 7-14 hari. 
                Aplikasi dan software installation disesuaikan kompleksitasnya.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="faq-item__question">Apakah ada garansi untuk layanan?</h3>
              <p className="faq-item__answer">
                Ya! Kami memberikan garansi untuk semua layanan. Website garansi 1 tahun, 
                SEO garansi ranking, software garansi instalasi sesuai paket.
              </p>
            </div>
            <div className="faq-item">
              <h3 className="faq-item__question">Bisakah request fitur kustom?</h3>
              <p className="faq-item__answer">
                Tentu saja! Kami bisa menambahkan fitur kustom sesuai kebutuhan bisnis Anda. 
                Konsultasikan dengan kami untuk penawaran yang disesuaikan.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="pricing-cta">
        <div className="pricing-cta__inner">
          <div className="pricing-cta__content">
            <h2 className="pricing-cta__title">Butuh Solusi Kustom?</h2>
            <p className="pricing-cta__subtitle">
              Kami juga menyediakan solusi yang disesuaikan sepenuhnya dengan kebutuhan unik bisnis Anda. 
              Konsultasi gratis untuk membantu menemukan solusi yang tepat.
            </p>
            <div className="pricing-cta__buttons">
              <Link to="/consultation" className="btn btn-primary btn-large">
                <span className="btn__icon">💬</span>
                <span>Konsultasi Gratis</span>
              </Link>
              <a href={WHATSAPP_PRICING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-large">
                <span className="btn__icon">📱</span>
                <span>Chat WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Pricing;
